module.exports = __webpack_public_path__ + "static/media/pressed.619a55f8.mp3";